<template>
  <div>
    <v-btn
      small
      color="orange"
      icon
      v-if="isAdmin && codeObj.code"
      :loading="loading"
      @click="toggleFavorite()"
      ><v-icon small>{{
        isFavorite ? "mdi-star" : "mdi-star-outline"
      }}</v-icon></v-btn
    >
  </div>
</template>

<script>
import ApiServices from "@/services/ApiServices";
import AdminMixin from "@/assets/js/AdminMixin";

export default {
  name: "FavoriteToggler",
  mixins: [AdminMixin],
  props: {
    codeObj: null,
  },
  data: function () {
    return {
      loading: false,
      localFavorite: null,
      favoriteChanged: false,
    };
  },
  methods: {
    toggleFavorite() {
      if (!this.codeObj) return;
      console.log("hi");
      this.loading = true;
      this.success = null;
      this.error = null;

      let isFav = this.isFavorite;
      isFav ? this.removeFavorite() : this.setFavorite();
    },
    setFavorite() {
      let adminUser = this.$store.state.admin;
      ApiServices.setFavorite(this.codeObj.code, this.codeObj.name, adminUser)
        .then((response) => {
          console.log(response.data);
          if (response.data.error) alert(response.data.error);
          if (response.data.success) {
            this.favoriteChanged = true;
            this.localFavorite = true;
          }
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.error = "An error occurred";
          this.loading = false;
        });
    },
    removeFavorite() {
      let adminUser = this.$store.state.admin;
      ApiServices.removeFavorite(this.codeObj.code, adminUser)
        .then((response) => {
          console.log(response.data);
          if (response.data.error) alert(response.data.error);
          if (response.data.success) {
            this.favoriteChanged = true;
            this.localFavorite = false;
          }
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.error = "An error occurred";
          this.loading = false;
        });
    },
  },
  computed: {
    isFavorite: function () {
      let fav = false;
      if (!this.favoriteChanged && this.codeObj) {
        fav = this.codeObj.favorite;
      } else {
        fav = this.localFavorite;
      }
      return fav;
    },
  },
};
</script>

<style scoped></style>
